import { render, staticRenderFns } from "./Form6Table.vue?vue&type=template&id=3b23d147"
import script from "./Form6Table.vue?vue&type=script&lang=ts"
export * from "./Form6Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports